import { sessionApi } from '../../api/sessionApi'

import { sessionSignal, sessionLoadedSignal, sessionErrorSignal, sessionExpirationTimestampSignal, sessionRefreshingSignal } from '../../state/signals/sessionSignals.js'
import { entityProxyModeSignal } from '../../state/signals/userSettingsSignals.js'

import { parseDate } from '../../utils/datetime'
import { entityProxy } from '../../utils/debug'

const convertAccessTokenToSession = (accessTokenEntity) => {
    const session = {
        accessToken: accessTokenEntity.token,
        //don't care about application/client ID
        expiresAt: accessTokenEntity.expires,
    }
    if (entityProxyModeSignal.value == true) {
        return entityProxy(session)
    }
    return session
}

export const fetchAccessTokenFromAuthCode = async (config, authCode) => {
    return await sessionApi.fetchAccessTokenFromAuthCode(config, authCode)
}

export const fetchSessionFromAuthCode = async (config, authCode) => {
    sessionLoadedSignal.value = false
    return await fetchAccessTokenFromAuthCode(config, authCode).then(
        (accessTokenEntity) => {
            if (accessTokenEntity == null) {
                return null
            }
            const session = convertAccessTokenToSession(accessTokenEntity)
            sessionSignal.value = session
            if (session.expiresAt) {
                sessionExpirationTimestampSignal.value = parseDate(session.expiresAt)?.getTime()
            }
            else {
                sessionExpirationTimestampSignal.value = Date.now()
            }
            sessionLoadedSignal.value = true
            return session
        }
    ).catch(
        (error) => {
            sessionSignal.value = null
            sessionErrorSignal.value = error
            throw error
        }
    )
}

export const fetchAccessTokenValidity = async (config, authCode) => {
    return await sessionApi.fetchAccessTokenValidity(config, authCode)
}

export const fetchSessionValidity = async (config, authCode) => {
    sessionLoadedSignal.value = false
    sessionSignal.value = null
    return await fetchAccessTokenValidity(config, authCode).then(
        (accessTokenEntity) => {
            if (accessTokenEntity == null) {
                return null
            }
            const session = convertAccessTokenToSession(accessTokenEntity)
            sessionSignal.value = session
            if (session.expiresAt) {
                sessionExpirationTimestampSignal.value = parseDate(session.expiresAt)?.getTime()
            }
            else {
                sessionExpirationTimestampSignal.value = Date.now()
            }
            sessionLoadedSignal.value = true
            return session
        }
    ).catch(
        (error) => {
            sessionErrorSignal.value = error
            throw error
        }
    )
}
export const refreshSession = async (config, accessToken) => {
    sessionRefreshingSignal.value = true
    sessionLoadedSignal.value = false
    return await sessionApi.refreshSession(config, accessToken).then(
        (session) => {
            sessionSignal.value = session
            if (session.expiresAt) {
                sessionExpirationTimestampSignal.value = parseDate(session.expiresAt)?.getTime()
            }
            else {
                sessionExpirationTimestampSignal.value = Date.now()
            }
            sessionLoadedSignal.value = true
            return session
        }
    ).catch(
        (error) => {
            sessionSignal.value = null
            sessionErrorSignal.value = error
            throw error
        }
    ).finally(
        () => {
            sessionRefreshingSignal.value = false
        }
    )
}
export const logout = (config) => {
    const url = `${config.ssoBaseUrl}/logout?clientid=4&redirectToReferer=true`
    window.location.href = url
}